window.hoculus = window.hoculus || {};

hoculus.domready = function(callback) {
	if (document.readyState != 'loading') callback();
	else document.addEventListener('DOMContentLoaded', callback);
}
hoculus.utils = {
    animateValue: function(element, start, end, duration){
        if (start === end) return;
        if(typeof start !== 'number' ||  typeof end !== 'number' || typeof duration !== 'number') return;
        var range = Math.round((end - start) * 100) / 100;
        var current = Math.round(start * 100) / 100;
        var increment = end > start? 1 : -1;
        var stepTime = Math.abs(Math.floor(duration / range));
        var timer = setInterval(function() {
            current += increment;
            element.innerHTML = current;
            if (increment > 0){
                if (current >= end) {
                    element.innerHTML = end;
                    clearInterval(timer);
                }
            }else{
                if (current <= end) {
                    element.innerHTML = end;
                    clearInterval(timer);
                }
            }
        }, stepTime);
    }
}
/* hoculus-section-revolution */
hoculus.txtType = function(){
    var parentThis = this;
    this.newEl = function(el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };
    this.tick = function (){
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];
        if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.querySelector('.wrap').innerText = this.txt;

        var that = this;
        var delta = 200 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
        }

        setTimeout(function() {
        that.tick();
        }, delta);
    }
    this.init = function(){
        var elements = document.querySelectorAll('.hoculus .typewriter-content');
        if (elements.length > 0){
            elements.forEach(function(e,i){
                var toRotate = e.getAttribute('data-type');
                var period = e.getAttribute('data-period');
                if (toRotate) {
                    parentThis.newEl(e, JSON.parse(toRotate), period);
                }
            });
        }
    }
    this.init();
}
/* hoculus-features-switch */
hoculus.ftSwitch = function(){
    var parent = this;
    this.update = function(active,container){
        counters = container.querySelectorAll('.feature-count');
        counters.forEach(function(e,i){
            var disabled = parseFloat(e.dataset.count);
            var enabled = parseFloat(e.dataset.countActive);
            if (active===true){
                hoculus.utils.animateValue(e,disabled,enabled,500);
            }else{
                hoculus.utils.animateValue(e,enabled,disabled,500);
            }
        })
    }
    this.init = function(){
        var elements = document.querySelectorAll('.hoculus.features-switch');
        elements.forEach(function(e,i){
            var $switch = $(e).find('.switch-container .switch input');
            parent.update($switch[0].checked,e);
            $switch.change(function(){
                parent.update(this.checked,e);
            });   
        });
    }
    this.init();
}
/* hoculus-delivey-forecast */
hoculus.dForecast = function(){
    var parent = this;
    this.shiftEndDay = function(dateObj){
        if (dateObj.getDay() == 0){
            dateObj.setDate(dateObj.getDate() + 1);
        }else if(dateObj.getDay() == 6){
            dateObj.setDate(dateObj.getDate() + 2);
        }
        return dateObj;
    }
    this.forecastCalc = function(element){
        var options = {'day': '2-digit'};
        var optionsNext = {'day': '2-digit', 'month': 'long'};
        var today = new Date();
        //today.setDate(today.getDate() + 5);
        var forecast = new Date();
        var forecastp = new Date();
        var todayNum = today.getDay();
        var add = 0;
        var addp = 1;
        if(todayNum == 0){
            add = 2;
        }else if(todayNum >= 1 && todayNum <= 4){
            add = 1
        }else if(todayNum==5){
            add = 3;
        }else{
            add = 9 - todayNum;
        }
        if (today.getHours() >= 15 && todayNum >= 1 && todayNum <= 5){
            add++;
        }
        forecast.setDate(today.getDate() + add);
        forecast = parent.shiftEndDay(forecast);
        forecastp.setDate(forecast.getDate() + addp);
        forecastp = parent.shiftEndDay(forecastp);
        element.querySelector('.forecast').innerText = forecast.toLocaleString('it-IT',options)+' - '+forecastp.toLocaleString('it-IT',optionsNext);
    }
    this.init = function(){
        var elements = document.querySelectorAll('.hoculus.delivery-forecast');
        elements.forEach(function(e,i){
            parent.forecastCalc(e);
        });
    }
    this.init();
}
hoculus.payoff = function(){
    var parent = this;
    this.highlight = function(container){
        var blocks = container.querySelectorAll('.background-timer');
        var settings = JSON.parse(container.dataset.hSettings);
        var i = 0;
        setInterval(function(){
            $(blocks).css({'color':'#000000','background-color':'#ffffff'});
            $(blocks).children('.icon').css({'color':settings.accent_color});
            $(blocks).children('.text').css({'color':'#000000'});
            $(blocks).eq(i).css({'color':'#ffffff','background-color':settings.accent_color});
            $(blocks).eq(i).children().css({'color':'#ffffff'});
            i++;
            if(i==3){i=0}
        },settings.interval)
    }
    this.init = function(){
        var elements = document.querySelectorAll('.hoculus.hoculus-payoff .action-bar');
        if (elements.length > 0){
            elements.forEach(function(e,i){
               if(JSON.parse(e.dataset.hSettings).highlight){
                    parent.highlight(e);
               }
            });
        }
    }
    this.init();
}
hoculus.videoPower = function () {
	var videos = document.querySelectorAll("video.hoculus-power-video");
	if (videos.length > 0) {
		console.log(videos);
		videos.forEach(function (e, i) {
			if (e.paused) {
				console.log("added");
				e.parentElement.addEventListener("click", function (event) {
					var video = this.querySelector("video.hoculus-power-video");
					if (video.paused) {
						video.play();
                    } 
                })
            }
        })
    }
}
hoculus.domready(function(){
    hoculus.txtType();
    hoculus.ftSwitch();
    hoculus.dForecast();
    hoculus.payoff();
    hoculus.videoPower();
});
